// services import
import { Loyalty } from './loyalty';
import { About } from './about';
import { Cashier } from './cashier';
import { CashierSession } from './cashier-session';
import { ConfigProvider } from './config';
import { Consignment } from './consignment';
import { CookieStreams } from './cookie-streams';
import { CurrentSession } from './current-session';
import { Customer } from './customer';
import { DataFeedAws } from './data-feed-aws';
import { DateSource } from './date-source';
import { DiscountRules } from './discount-rules';
import { Domain } from './domain';
import { Eos } from './eos';
import { EpsonFiscalPrinter } from './epson-fiscal-printer';
import { Event } from './event';
import { FileDownloader } from './file-downloader';
import { FiscalPrinter } from './fiscal-printer';
import { FocusManager } from './focus-manager';
import { ImageRootProvider } from './image-root';
import { Intercom } from './intercom';
import { IntercomAppIdProvider } from './intercom-app-id';
import { IsTestProvider } from './is-test';
import { Language } from './language';
import { LanguageNamesProvider } from './language-names';
import { Legacy } from './legacy';
import { LegacyBase } from './legacy-base';
import { LegacyProduct } from './legacy-product';
import { LegacySku } from './legacy-sku';
import { LocalJsonStorage } from './local-json-storage';
import { LocalStorageProvider } from './local-storage';
import { Location } from './location';
import { LocationManager } from './location-manager';
import { NavigatorProvider } from './navigator';
import { NotificationManager } from './notification-manager';
import { PayNl } from './pay-nl';
import { PayNlRequests } from './pay-nl-requests';
import { Printer } from './printer';
import { PromiseConstructorProvider } from './promise-constructor';
import { RedirectAnonymousToGateProvider } from './redirect-anonymous-to-gate';
import { RetailTransactions } from './retail-transactions';
import { RouteStreams } from './route-streams';
import { Sales } from './sales';
import { SalesCalculations } from './sales-calculations';
import { SalesManager } from './sales-manager';
import { SalesReports } from './sales-reports';
import { SchedulerProvider } from './scheduler';
import { ScopeStreams } from './scope-streams';
import { Sentry } from './sentry';
import { Session } from './session';
import { SessionJsonStorage } from './session-json-storage';
import { SessionManager } from './session-manager';
import { SessionRequests } from './session-requests';
import { SessionStorageProvider } from './session-storage';
import { SettingsManager } from './settings-manager';
import { SettingsOverrides } from './settings-overrides';
import { Sku } from './sku';
import { Softwear } from './softwear';
import { SpynlBaseDefault } from './spynl-base';
import { StandardErrorParserProvider } from '@shared/app/scripts/services/standard-error-parser';
import { TimeZoneProvider } from './time-zone';
import { Transit } from './transit';
import { UiDelayProvider } from './ui-delay';
import { VersionProvider } from './version';
import { Withdrawal } from './withdrawal';
import { FashionCheque } from './fashion-cheque';

export const services: any[] = [
  // services export
  FashionCheque,
  Loyalty,
  About,
  Cashier,
  CashierSession,
  ConfigProvider,
  Consignment,
  CookieStreams,
  CurrentSession,
  Customer,
  DataFeedAws,
  DateSource,
  DiscountRules,
  Domain,
  Eos,
  EpsonFiscalPrinter,
  Event,
  FileDownloader,
  FiscalPrinter,
  FocusManager,
  ImageRootProvider,
  Intercom,
  IntercomAppIdProvider,
  IsTestProvider,
  Language,
  LanguageNamesProvider,
  Legacy,
  LegacyBase,
  LegacyProduct,
  LegacySku,
  LocalJsonStorage,
  LocalStorageProvider,
  Location,
  LocationManager,
  NavigatorProvider,
  NotificationManager,
  PayNl,
  PayNlRequests,
  Printer,
  PromiseConstructorProvider,
  RedirectAnonymousToGateProvider,
  RetailTransactions,
  RouteStreams,
  Sales,
  SalesCalculations,
  SalesManager,
  SalesReports,
  SchedulerProvider,
  ScopeStreams,
  Sentry,
  Session,
  SessionJsonStorage,
  SessionManager,
  SessionRequests,
  SessionStorageProvider,
  SettingsManager,
  SettingsOverrides,
  Sku,
  Softwear,
  SpynlBaseDefault,
  StandardErrorParserProvider,
  TimeZoneProvider,
  Transit,
  UiDelayProvider,
  VersionProvider,
  Withdrawal,
];
